<style scoped>
    .expand-row{
        margin-bottom: 16px;
    }
   /* td .ivu-table-expanded-cell{
        padding: 10px !important ;
    }*/
    .tableTcl .ivu-table-expanded-cell{
        padding: 2px 5px !important;
        background-color:red;
        /*overflow-x: scroll;*/
    }
</style>
<template>
    <div>
        <!-- {{rows3}} -->
        <Table border :columns="columns2" :data="data2" class="tableTcl"></Table>
        <!-- <button @click="rng">111</button> -->
    </div>
</template>
<script>
    import axios from 'axios';
    import config from 'config/apiConfig';
    import language from 'api/language.js'
    export default {
        data(){
            return{
               
                columns2: [
                    {
                        title: language.shouhuokehu,
                        width:100,   
                        align:'center',
                        key: 'customerName'
                    },
                    {
                        title: language.cangku,
                        key: 'warehouseName',
                        width:70
                    },
                    {
                        title: language.danjuhao,
                        width:115, 
                        align:'center',
                        key: 'saleNoticeNo',
                    },
                    {
                        title: language.kunbaohao,
                        width:100,  
                        align:'center',
                        key: 'serialCode'
                    },
                    {
                        title: language.pinzhong,
                        key: 'categoryCode',
                        align:'center',
                        width:60
                    },
                    {
                        title: language.paihao,
                        key: 'shopsign',
                        width:120,
                        align:'center'
                    },
                    {
                        title: language.guige,
                        key: 'specification',
                        width:100,
                        align:'center'
                    },
                    {
                        title: language.shuliang,
                        key: 'secondQty',
                        align:'center',
                        width:70
                    },
                    {
                        title: language.zhongliang,
                        key: 'primaryQty',
                        width:70
                    },
                    {
                        title: language.neiwaiban,
                        key: 'exposedName',
                        align:'center',
                        width:100
                    },
                    {
                        title: language.mujuanhao,
                        key: 'reelNo',
                        align:'center',
                        width:100
                       
                    },
                    {
                        title: language.mujuanguige,
                        key: 'rawPieceSpecdesc',
                        align:'center',
                        width:100
                    },
                    {
                        title: language.mujuanzhongliang,
                        key: 'rawPrimaryQty',
                        align:'center',
                        width:100
                    },
                    
                    
                    
                    
                    
                    
                    {
                        title: language.chukuzhuangtai,
                        key: 'outStatusName',
                        align:'center',
                        width:100
                    },
                    {
                        title: language.shenhezhuangtai,
                        key: 'applyStatusName',
                        align:'center',
                        width:100
                    },
                    {
                        title: language.beizhu,
                        key: 'remarks',
                        align:'center',
                        width:250
                    },
                    {
                        title: language.caozuo,
                        key: 'remarks',
                        width:100,
                        align:'center',

                        render: (h, params) => {
                            if(params.row.applyStatus==20){
                            
                            return h('div', [
                                h('Button', {
                                    props: {
                                        size: 'small'
                                    },
                                    style:{
                                        border:'none',
                                        backgroundColor:'#fff',
                                        // margin:"0 auto"
                                        fontSize:"20px"
                                    },
                                    on:{
                                        click: ()=>{
                                            this.removelist(params)
                                            // alert(111)
                                        }
                                    }
                                },[
                                    h('Icon', {
                                        props: {
                                            type: "reply-all"
                                        }
                                    })

                                ])
                            ]);
                        }else{
                            return ""
                        }
                        }
                    }
                ],
                data2:[],
                // rows:this.rows3
                //row:rows
           // titles:[
           //      "仓库","原料品种","原料牌号","原料规格","重量","捆包号","内/外版","入库日期","交货期","成品规格","成品重量","成品数量","操作",
           // ]
                //
            }
        },
        props: {
            rows3: Object,
        },
        methods:{
            rng(indexs){
                let that=this;
                that.language=language
                axios.post(config.queryOntOutApplyLine,{
                    "applyId": that.rows3.applyId,
                    "nopage":"true"
                }).then(function(response){
                    console.log(response)
                    that.$emit('on-change',response.data.resultData.productList)
                    that.data2=response.data.resultData.productList
                })
            },
            removelist(params){
                let that = this;
                let paramsData={
                    applyCode:that.data2[params.index].applyCode,
                    applySubid:that.data2[params.index].applySubid
                }
            console.log(that.data2)
            axios.post(config.reverseTHApply,paramsData).then(function(response){
                if(response.data.resultCode==1){
                    that.$Message.info(language.caozuochenggong)
                    that.rng()
            }
            if(response.data.resultCode==0){
                that.$Message.info(response.data.fsuffix)
                that.$emit('on-change',response.data.resultMsgDetail)
            }
            })
            }
        },
       
        mounted(){
             this.rng()
        }

    };
</script>


// WEBPACK FOOTER //
// ladingseeexpand.vue?a21b5410